import styled from 'styled-components';

import media from 'theme/media';
import zIndex from 'theme/zIndex';

const getBottomMobileIndent = (props) => {
    if (props.buttonPosition) {
        return props.buttonPosition;
    } else if (props.isPressedAboveMenu || props.forSpinner) {
        return '72px';
    }
    return '24px';
};

const getBottomTabletIndent = (props) => {
    if (props.isNewMainScreen && props.isPressedAboveMenu) {
        return '88px';
    } else if (!props.isNewMainScreen && props.isPressedAboveMenu) {
        return '128px';
    } else if (props.forSpinner) {
        return '72px';
    }
    return '24px';
};

const getBottomDesktopIndent = (props) => {
    if (props.isNewMainScreen && props.isPressedAboveMenu) {
        return '112px';
    } else if ((!props.isNewMainScreen && props.isPressedAboveMenu) || props.forSpinner) {
        return '72px';
    }
    return '24px';
};

export const Container = styled.div`
    position: ${(props) => (props.insideStories ? 'absolute' : 'fixed')};
    bottom: ${(props) => getBottomMobileIndent(props)};
    left: 0;
    right: 0;
    height: 0;
    pointer-events: none;
    z-index: ${zIndex.bottomPanelIndex};
    display: ${(props) => (props.buttonPosition?.isScrolling ? 'none' : null)};

    ${media.tablet720} {
        bottom: ${(props) => getBottomTabletIndent(props)};
    }

    ${media.desktop1224} {
        bottom: ${(props) => getBottomDesktopIndent(props)};
        left: ${(props) => (props.fullwidth ? '360px' : null)};
    }
`;
export const Inner = styled.div`
    margin: 0 auto;
    padding: 0 24px;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: ${(props) => (props.isRightAligned ? 'flex-end' : 'center')};
    box-sizing: border-box;
    /* content width 480 */
    max-width: 528px;
    min-height: 56px;

    ${media.tablet720} {
        padding: ${(props) => (props.fullwidth ? '0 144px' : '0 24px')};
        /* content width 504px */
        max-width: ${(props) => (props.fullwidth ? '100%' : props.isNewMainScreen ? '888px' : '552px')};
    }

    ${media.tablet1080} {
        max-width: ${(props) => (props.fullwidth ? '1080px' : props.isNewMainScreen ? '888px' : '840px')};
    }

    ${media.desktop1224} {
        margin: ${(props) => (props.fullwidth ? '0' : '0 auto')};
    }
`;
